import { render, staticRenderFns } from "./SkeletonProductRecommendationItem.vue?vue&type=template&id=f1a02114&"
import script from "./SkeletonProductRecommendationItem.vue?vue&type=script&lang=js&"
export * from "./SkeletonProductRecommendationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports